import { CustomElement } from '@aurelia/runtime-html';
export const name = "view-header";
export const template = "<div class=\"page-header app-view-header\">\r\n  <span class=\"page-header__title\">\r\n    <i class=\"fa-solid ${icon} page-header__icon\"></i>\r\n    <span>${titleKey | t}</span>\r\n  </span>\r\n</div>\r\n";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
